<template>
  <b-row>
    <b-card class="mt-2 col-12">
      <b-tabs>
        <b-tab
          v-for="tab in tabs"
          :key="tab.title"
          :title="tab.title"
          lazy
          @click.prevent="setActiveTabName(tab.mode)"
        >
          <b-col cols="12">
            <SearchFilter 
              ref="tableCommon"
              :mode="tab.mode" 
              @handleSubmit="searchFilterSubmit"
            />
          </b-col>

        </b-tab>
      </b-tabs>

    </b-card>

    <b-col
      v-for="tab in activeTab"
      :id="tab"
      :key="tab"
      cols="12"
      >
      <commonTable
        ref="tableCommon"
        :mode="tab"
        @handleSend="getManageDetail"
        @handleGroup="getManageGroup"
      />
    </b-col>

  </b-row>
</template>

<script>
import {
  BRow, 
  BCol, 
  BTabs, 
  BTab, 
  BButton, 
  BCard, 
  BCardHeader, 
  BCardBody,
  BOverlay,
} from 'bootstrap-vue'
import commonTable from './components/commonTable.vue'
import commonTableHeader from "./components/commonTableHeader.js";
import SearchFilter from "./components/SearchFilter.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
    BOverlay,
  },
  data() {
    return {
      tabs: [
        { title: 'รายการเจ้าหน้าที่', mode: 'List' },
      ],
      activeTab: ['List'],
      tableHeader: commonTableHeader,
      showOverlay: false,
    }
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    setActiveTabName(name) {
      this.activeTab = []
      this.activeTab.push(name)
    },
    getManageDetail(id) {
      // let routeData = this.$router.resolve({name: 'LawScreeningManage', query: { id:id } });
      // window.open(routeData.href, '_blank');
    },
    getManageGroup(id) {
      // let routeData = this.$router.resolve({name: 'LawGroupdManage' });
      // window.open(routeData.href, '_blank');
      const routeData = this.$router.resolve({ name: 'LeaderDeptRecieve', query: { id } })
      window.open(routeData.href, '_blank')
    },
    searchFilterSubmit(params) {
      // params.userActive = params.userActive = userData.userId();
      // params.tabName = this.getActiveTabSubName();
      this.$refs.tableCommon[0].onSearchSubmit(params);    
        
    },
  },
}
</script>

 <style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
